import { jsPDF } from 'jspdf';

import { translate } from '../../../i18n/I18nProvider';

const createPdf = ({ number, src, icc }) => {
  const doc = new jsPDF();

  doc.text(translate('SWAP_SIMCARD.ESIM_SUMMARY_1'), 10, 20);
  doc.text(`${translate('SWAP_SIMCARD.ESIM_SUMMARY_2')} ${number}`, 10, 50);
  doc.text(translate('SWAP_SIMCARD.ESIM_SUMMARY_4'), 10, 70);
  doc.text(translate('SWAP_SIMCARD.ESIM_SUMMARY_5'), 10, 80);
  doc.text(translate('SWAP_SIMCARD.ESIM_SUMMARY_7_5'), 10, 100);
  doc.text(translate('SWAP_SIMCARD.ESIM_SUMMARY_7'), 10, 120);
  doc.addImage(src, 'PNG', 80, 140, 45, 45);
  doc.text(`icc: ${icc}`, 10, 220);
  doc.text(translate('SWAP_SIMCARD.ESIM_5'), 10, 240, { maxWidth: 180 });
  doc.save(`QR code for number ${number}`);
};

export default createPdf;
